export function divideIntoRows<T>(items: T[], perRow: number) {
  return items.reduce(
    (rows, item, index) => {
      let lastRow = rows[rows.length - 1]
      if (lastRow.length >= perRow) {
        lastRow = []
        rows.push(lastRow)
      }
      lastRow.push(item)
      return rows
    },
    [[]] as T[][]
  )
}

export function sortAscending<T>(arr: T[], selector?: (item: T) => any) {
  return arr.sort((i1, i2) => {
    const r1 = selector ? selector(i1) : i1
    const r2 = selector ? selector(i2) : i2
    if (r1 === r2) {
      return 0
    }
    return r1 < r2 ? -1 : 1
  })
}

export function sortDescending<T>(arr: T[], selector?: (item: T) => any) {
  return arr.sort((i1, i2) => {
    const r1 = selector ? selector(i1) : i1
    const r2 = selector ? selector(i2) : i2
    if (r1 === r2) {
      return 0
    }
    return r1 < r2 ? 1 : -1
  })
}

export function maxArray<T>(arr: T[], selector: (item: T) => number, start: number) {
  return arr.reduce((max, item) => {
    const value = selector(item)
    return max > value ? max : value
  }, start)
}

export function sumArray<T>(arr: T[], selector: (item: T) => number) {
  return arr.reduce((sum, item) => {
    const value = selector(item)
    return sum + value
  }, 0)
}
